var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationinline = function SvgNotificationinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 1.893a.763.763 0 0 0-.764.763v.458a3.82 3.82 0 0 0-3.053 3.74v.45a4.6 4.6 0 0 1-1.158 3.043l-.176.198a.762.762 0 0 0 .57 1.272h9.16a.765.765 0 0 0 .571-1.272l-.177-.198a4.6 4.6 0 0 1-1.157-3.044v-.448a3.82 3.82 0 0 0-3.053-3.74v-.459a.763.763 0 0 0-.764-.763M9.08 13.66c.286-.286.446-.675.446-1.08H6.473a1.527 1.527 0 0 0 2.607 1.08"
  })));
};
export default SvgNotificationinline;